// extracted by mini-css-extract-plugin
module.exports = {"switchButtonWrapper":"SwitchButton_switchButtonWrapper__v9US1","noPadding":"SwitchButton_noPadding__Bwqvk"};